import React, { useState, useEffect } from 'react';
import isMobile from '~/utils/is-mobile';
import dabangBridge from '~/utils/bridge';
import apiCall, { TEST_URL, LIVE_URL } from '~/utils/apiCall';
import useAuth from '~/hooks/useAuth';
import isBrowser from '~/utils/is-browser';

const initState = {
  ableMission1: null, //true 이벤트 소문내기, false 내일도전하기, ,null미션 제출하기
  mission1Count: 0,
  ableMission2: false, //true 이벤트 참여O, false 이벤트 참여X
  alertMessage: '',
  statusCode: 0,
};

export const useTvc = () => {

  const isM = isMobile.any();
  const { authKey } = useAuth();  
  const tempAuthKey = (authKey || (isBrowser() && sessionStorage.getItem('authKey')) || '')
  const [ missionState, setMissionState ] = useState(initState)

  useEffect(()=> {
    if (tempAuthKey) {
      getUserInfo(tempAuthKey);

    } else {
      setMissionState(prev => ({
        ...prev, 
        statusCode: 501,
        alertMessage: "로그인 후 이벤트 참여가 가능합니다.",
      }));
    }
  },[tempAuthKey])

  useEffect(() => {
    if (!window.Kakao.isInitialized()) window.Kakao.init('7b905539e95a55efabd3ba6320ba6bae');
  }, []);

  const getUserInfo = async authKey => {
    if (isBrowser()) {
      sessionStorage.clear();
      sessionStorage.setItem('authKey', authKey);
    }

    const host = process.env.NODE_ENV === 'development' ? TEST_URL : LIVE_URL
    
    try {
      const { result, code } = await apiCall.get(`${host}/api/v1/event/2023/dabang/tvc`, { authKey });

      const temp = {
        ableMission1: result?.mission1Status ?? null,
        mission1Count: result?.mission1Count ?? 0,
        ableMission2: result?.mission2Status ?? false,
        statusCode: code,
        alertMessage: getMessage(code),
      }

      setMissionState(temp);
      
    } catch(error) {
      console.log(error);
    }
  }

  const getMessage = (code) => {
    //본인인증을 안한경우, 로그인 안한거는 애초에 api로직 타지도 않는다.
    if (code === 502 || code === 508) {
      return '본인인증을 한 회원에 한아여 이벤트 참여가 가능합니다.';
    } 

    if (code === 505) {
      return "본 이벤트는 중개사 계정은 참여할 수 없습니다.";
    }

    if (code === 506) {
      return "이벤트 기간이 아닙니다."
    }

    return '이벤트 참여가 불가 합니다.';
  }

  const updateAbleMisssionState = (updateState) => {
    setMissionState(prev => ({...prev, ...updateState}));
  }

  const isValidAuth = () => {
    //인앱이 아닌, pc로 접근을 할경우
    if (dabangBridge.getPlatform() === 'web' && !isM) {
      alert('다방앱에서 참여가능 한 이벤트입니다!');
      window.location.href = `${window.location.origin}/2023/03/tvcPc/`;
      return false;
    }
    
    //모바일인데 인앱이 아닌 외부 브라우저를 통한 접근을할경우
    if (dabangBridge.getPlatform() === 'web' && isM) {
       window.location.href = 'https://dabang.app.link/fKW8li6vjyb';
       return false;
    }

    if ( 
      missionState.statusCode === 502 || 
      missionState.statusCode === 508 || 
      missionState.statusCode === 501 ||
      missionState.statusCode === 506 
    ) {
      alert(missionState.alertMessage || '이벤트 참여가 불가 합니다.');

      if (missionState.statusCode === 502 || missionState.statusCode === 508) {

        //아이폰에서의 다방앱에서의 웹뷰일때 처리
        dabangBridge.ios(call => {
          console.log('IOS');
          call.callHandler('ObjC Echo', {
            cmd: 'showAuthAndReload',
          });
        });
    
        //앤드로이드에서의 다방앱에서의 웹뷰일때 처리
        dabangBridge.android(call => {
          console.log('android');
          call.showAuthAndReload();
        });
        
      } else if (missionState.statusCode === 501) {
        dabangBridge.ios(call => {
          console.log('IOS');
          call.callHandler('ObjC Echo', {
            cmd: 'showLoginAndReload',
          });
        });
    
        dabangBridge.android(call => {
          console.log('android');
          call.showLoginAndReload();
        });
      } 
      return false;
    }
    return true;
  }

  return {
    ableMission1: missionState.ableMission1,
    mission1Count: missionState.mission1Count,
    ableMission2: missionState.ableMission2,
    updateAbleMisssionState,
    isValidAuth,
  }
};
